/**
 * UIkit: solo core + componenti usati nel sito.
 * Il set completo di icone (uikit-icons) non serve: frecce e chiusura sono già nel core.
 * I componenti dist richiedono 'uikit-util', risolto con un alias in webpack.mix.js
 */
import UIkit from 'uikit/dist/js/uikit-core';
import Slideshow from 'uikit/dist/js/components/slideshow';
import SlideshowParallax from 'uikit/dist/js/components/slideshow-parallax';
import Slider from 'uikit/dist/js/components/slider';
import Filter from 'uikit/dist/js/components/filter';
import Lightbox from 'uikit/dist/js/components/lightbox';
import jquery from "../../node_modules/jquery/src/jquery.js";

import barba from "@barba/core";
import LocomotiveScroll from 'locomotive-scroll';
//import Swiper, { Navigation, Pagination, Autoplay, FreeMode } from 'swiper';

UIkit.component('slideshow', Slideshow);
UIkit.component('slideshowParallax', SlideshowParallax);
UIkit.component('slider', Slider);
UIkit.component('filter', Filter);
UIkit.component('lightbox', Lightbox);

/**
 * Rende disponibili le librerie nello scope globale.
 * Alternativamente, spostare gli import in app.js
 * Plyr viene caricato solo quando serve, v. resources/js/plyr.js e loadPlyr() in app.js
 */
window.UIkit = UIkit;
window.$ = jquery;
window.barba = barba;
window.LocomotiveScroll = LocomotiveScroll;
//Swiper.use([Navigation, Pagination, Autoplay, FreeMode]);
//window.Swiper = Swiper;

/**
 * Lazysizes
 */
import lazySizes from 'lazysizes';
lazySizes.cfg.init = false; // init manuale, v. sotto
lazySizes.cfg.loadMode = 1; // 1 = only load visible elements
window.lazySizes = lazySizes;
